
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { ShoppingBag, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import OrderHistory from "@/components/OrderHistory";

const OrderHistoryPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto text-center">
          <ShoppingBag className="mx-auto h-12 w-12 text-gray-400 mb-4" />
          <h1 className="text-2xl font-bold mb-2">Connexion requise</h1>
          <p className="text-gray-600 mb-4">
            Veuillez vous connecter pour accéder à votre historique de commandes.
          </p>
          <Button onClick={() => navigate("/account")}>
            Se connecter
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <Button 
          variant="ghost" 
          className="mb-6 hover:bg-gray-100"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Retour
        </Button>

        <div className="bg-white rounded-lg shadow-sm p-8">
          <div className="flex items-center gap-4 mb-8">
            <ShoppingBag className="h-8 w-8 text-primary" />
            <div>
              <h1 className="text-2xl font-bold">Historique des commandes</h1>
              <p className="text-gray-600">
                Consultez vos commandes passées et leur statut
              </p>
            </div>
          </div>

          <OrderHistory />
        </div>
      </div>
    </div>
  );
};

export default OrderHistoryPage;
